// externals
import axios from 'axios';
import type { AxiosInstance } from 'axios';

export const axiosInstance: AxiosInstance = axios.create();
